import { useTranslation } from 'react-i18next';
import { useState, useEffect, useRef } from 'react';
import { useHttpClient } from '../../../shared/http-client';
import { toast } from 'react-toastify';
import { TrashIcon } from '@heroicons/react/outline';
import { Driver, SaleRepresentativeFormValues } from './types';
import { Input } from '../../../elements/input';

interface AreaAssignmentFormProps {
    item?: Driver;
    close: () => void;
}

export const AreaAssignmentForm = ({ item, close }: AreaAssignmentFormProps) => {
    const { t } = useTranslation() as { t: (key: string) => string };
    const { api, state } = useHttpClient();
    const [areas, setAreas] = useState<any[]>([]);
    const [areaToAdd, setAreaToAdd] = useState<string>('');

    const [addressQuery, setAddressQuery] = useState<string>('');
    const [isAddressLoading, setIsAddressLoading] = useState(false);
    const [addressResults, setAddressResults] = useState<any[]>([]);

    const initialData: SaleRepresentativeFormValues = {
        area_ids: item
            ? Array.isArray(item.areas)
                ? item.areas.map((a) => a.id)
                : item.area
                    ? [item.area.id]
                    : []
            : [],
        email: (item as any)?.email ?? null,
        address: (item as any)?.address ?? null,
        latitude: (item as any)?.latitude ?? null,
        longitude: (item as any)?.longitude ?? null
    };

    const [formData, setFormData] = useState<SaleRepresentativeFormValues>(initialData);

    useEffect(() => {
        api('/fleet/areas/', 'GET');
    }, []);



    const [saveStep, setSaveStep] = useState<null | 'creating' | 'patching' | 'setting_areas'>(null);
    const [currentDriverId, setCurrentDriverId] = useState<number | null>(item?.id ?? null);
    const submitSnapshotRef = useRef<{ email: string; address: string; latitude?: string | number; longitude?: string | number; area_ids: number[], is_commercial: boolean } | null>(null);

    useEffect(() => {
        const q = addressQuery.trim();
        if (!q) {
            setIsAddressLoading(false);
            setAddressResults([]);
            return;
        }

        setIsAddressLoading(true);
        const timer = window.setTimeout(() => {
            const url = `/fleet/geocoding/autocomplete/?q=${encodeURIComponent(q)}&country=ES&limit=10`;
            api(url, 'GET');
        }, 350);

        return () => {
            window.clearTimeout(timer);
        };
    }, [addressQuery]);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();

        if (!item?.id) {
            if (!formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
                toast.error(t('common.message.error'));
                return;
            }
        }

        /* if (!formData.address || !formData.address.trim()) {
            console.log('first', formData.address)
            toast.error(t('common.message.error'));
            return;
        } */

        if (!formData.address || !formData.address.trim()) {
            submitSnapshotRef.current = {
            email: '',
            address: '',
            latitude: undefined,
            longitude: undefined,
            area_ids: formData.area_ids,
            is_commercial: true
        };
        }else{
            submitSnapshotRef.current = {
            email: formData.email,
            address: formData.address,
            latitude: formData.latitude,
            longitude: formData.longitude,
            area_ids: formData.area_ids,
            is_commercial: true
        };
        }

        

        if (item?.id) {
            setCurrentDriverId(item.id);
            setSaveStep('patching');
            const payload: any = { is_commercial: true };
            if (formData.address && formData.address.trim()) {
                payload.address = formData.address;
                payload.latitude = formData.latitude;
                payload.longitude = formData.longitude;
            }
            api(`/fleet/drivers/${item.id}/`, 'PATCH', payload);
            return;
        }

        setSaveStep('creating');
        console.log('formData', formData)
        const payload: any = { email: formData.email, is_commercial: true };
        if (formData.address && formData.address.trim()) {
            payload.address = formData.address;
            payload.latitude = formData.latitude;
            payload.longitude = formData.longitude;
        }
        api('/fleet/drivers/create_from_email/', 'POST', payload);
    };

    useEffect(() => {
        if (state.data && state.path?.includes('/fleet/areas/') && state.method === 'GET') {
            if (Array.isArray(state.data.results)) {
                setAreas(state.data.results);
            }
        }

        if (
            state.data &&
            (state.path?.includes('/api/fleet/geocoding/autocomplete/') || state.path?.includes('/fleet/geocoding/autocomplete/')) &&
            state.method === 'GET'
        ) {
            const results = Array.isArray((state.data as any)?.results) ? (state.data as any).results : [];
            setAddressResults(results);
            setIsAddressLoading(false);
        }

        if (state.data && !state.loading && state.path?.includes('/fleet/drivers/')) {
            const snapshot = submitSnapshotRef.current;
            if (saveStep === 'creating' && state.method === 'POST' && state.path?.includes('/drivers/create_from_email/')) {
                const createdId = state.data?.id ?? state.data?.driver?.id;
                if (!createdId) {
                    toast.error(t('common.message.error'));
                    setSaveStep(null);
                    return;
                }

                setCurrentDriverId(createdId);
                setSaveStep('patching');
                api(`/fleet/drivers/${createdId}/set_areas/`, 'PATCH', { area_ids: snapshot?.area_ids ?? formData.area_ids });
            }

            if (saveStep === 'patching' && state.method === 'PATCH' && !state.path?.includes('/set_areas/')) {
                const idToUse = currentDriverId ?? item?.id;
                if (!idToUse) {
                    toast.error(t('common.message.error'));
                    setSaveStep(null);
                    return;
                }
                setSaveStep('setting_areas');
                api(`/fleet/drivers/${idToUse}/set_areas/`, 'PATCH', { area_ids: snapshot?.area_ids ?? formData.area_ids });
            }

            if (state.method === 'PATCH' && state.path?.includes('/set_areas/')) {
                //toast.success(t('common.message.saved'));
                setSaveStep(null);
                submitSnapshotRef.current = null;
                close();
            }
        }

        if (state.error) {
            if (state.error.error && state.error.error == 'Driver already exists for this user') {
                toast.error(`${t('common.error.already-driver-exist')}`);
            } else if (state.error.error && state.error.error == 'No user found with this email') {
                toast.error(`${t('common.error.no-email-exist')}`);
            } else if (state.error.error && state.error.error == "Query must be at least 3 characters") {

            } else {
                toast.error('Server Error');
            }
        }
    }, [state, close, t, saveStep, currentDriverId, item]);

    return (
        <form onSubmit={handleSubmit} className="space-y-4">
            {item ? <div className="mb-4 p-4 bg-gray-50 rounded-lg">
                <h3 className="font-semibold text-gray-900 mb-1">{item.full_name}</h3>
            </div> : ''}

            {!item ? (
                <Input
                    label={t('usuario.form.email')}
                    type="email"
                    placeholder={t('usuario.form.email')}
                    name="email"
                    value={formData.email}
                    onChange={(value) => setFormData({ ...formData, email: String(value.email ?? '') })}
                />
            ) : null}

            <Input
                label={t('conductores.form.default_departure_address')}
                type="text"
                placeholder={t('conductores.form.default_departure_address')}
                name="address"
                value={formData.address}
                onChange={(value) => {
                    const next = String(value.address ?? '');
                    setFormData({ ...formData, address: next, latitude: '', longitude: '' });
                    setAddressQuery(next);
                }}
            />

            {isAddressLoading ? (
                <div className="text-xs text-gray-500 pt-2">{t('common.loading')}</div>
            ) : null}

            {addressResults.length > 0 ? (
                <div className="mt-2 border border-gray-200 rounded-md bg-white max-h-56 overflow-auto">
                    {addressResults.map((r: any, idx: number) => (
                        <button
                            key={idx}
                            type="button"
                            onClick={() => {
                                setFormData({
                                    ...formData,
                                    address: r.label,
                                    latitude: r.latitude,
                                    longitude: r.longitude
                                });
                                setAddressQuery(r.label);
                                setAddressResults([]);
                            }}
                            className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100"
                        >
                            {r.label}
                        </button>
                    ))}
                </div>
            ) : null}


            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                    {t('common.label.area')}
                </label>
                <select
                    value={areaToAdd}
                    onChange={(e) => {
                        const nextId = e.target.value ? parseInt(e.target.value) : NaN;
                        if (!Number.isNaN(nextId) && !formData.area_ids.includes(nextId)) {
                            setFormData({ ...formData, area_ids: [...formData.area_ids, nextId] });
                        }
                        setAreaToAdd('');
                    }}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#006bc6] focus:border-transparent"
                >
                    <option value="">{t('Select')}</option>
                    {areas.map((area) => (
                        <option key={area.id} value={area.id}>
                            {area.name}
                        </option>
                    ))}
                </select>

                <div className="mt-3 space-y-2">
                    {formData.area_ids.length === 0 ? (
                        <div className="text-sm text-gray-500">{t('common.label.sin-area')}</div>
                    ) : (
                        formData.area_ids
                            .map((id) => areas.find((a) => a.id === id) ?? { id, name: String(id) })
                            .map((area) => (
                                <div key={area.id} className="flex items-center justify-between px-3 py-2 bg-gray-50 rounded-lg border border-gray-200">
                                    <div className="text-sm text-gray-900">{area.name}</div>
                                    <button
                                        type="button"
                                        onClick={() =>
                                            setFormData({
                                                ...formData,
                                                area_ids: formData.area_ids.filter((x) => x !== area.id)
                                            })
                                        }
                                        className="inline-flex items-center gap-2 text-red-600 hover:text-red-700"
                                    >
                                        <TrashIcon className="h-4 w-4" />
                                    </button>
                                </div>
                            ))
                    )}
                </div>
            </div>

            <div className="flex justify-end gap-3 pt-4 border-t border-gray-200">
                <button
                    type="button"
                    onClick={close}
                    className="px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg font-medium transition-all"
                >
                    {t('common.button.cancel')}
                </button>
                <button
                    type="submit"
                    className="px-4 py-2 bg-[#006bc6] hover:bg-[#0056a3] text-white rounded-lg font-medium transition-all"
                >
                    {t('common.button.save')}
                </button>
            </div>
        </form>
    );
};
